<div class="pag-container">
  <!-- <h1>{{labelTest}}</h1> -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <div class="page-header">

    <div>
      <h1 class="bold-text header-blue">
        {{ 'baskets.promoList' | translate }}
      </h1>

      <h3 class="thin-text header-blue">
        {{ 'baskets.promoview_descr' | translate }} {{ basketCode }}
      </h3>
    </div>

    <div>
      <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="onGoBack()"
        [label]="'common.back' | translate">
      </button>
    </div>

  </div>

  <div class="ui-g-12 prova" *ngIf="showTable">


    <!-- nuove colonne da guardare in issue -->
    <app-campaign-3-kontable #promoListDetailKontable [columns]="[         
{ field: 'codice_offerta', title: 'baskets.codice_offerta',filterType: textFilter },
{ field: 'descrizione_offerta', title: 'baskets.descrizione_offerta',filterType: textFilter},
{ field: 'codice_meccanica', title: 'baskets.codice_meccanica' , filterType: textFilter},
{ field: 'descrizione_meccanica', title: 'baskets.descrizione_meccanica',filterType: textFilter},

{ field: 'data_inizio_meccanica', title: 'baskets.data_inizio_meccanica',filterType: dateFilter},
{ field: 'data_fine_meccanica', title: 'baskets.data_fine_meccanica',filterType: dateFilter},
{ field: 'caso_uso', title: 'baskets.ambito',filterType: textFilter}

]" [paginationType]="paginationType" [showInfoButton]="false" [showDetailsButton]="false" [showRecoverButton]="false"
      [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false" [showDeleteButton]="false"
      [allowSelectRow]="false" [additionalRowCommands]="actions" [filterBySingleColumn]="true"
      [source]="basketPromoList">


      <ng-template #actions let-row>

        <div class="d-flex justify-content-center ">
          <button data-testid-generic="goToAction" (click)="goToThePromo(row)"
            [attr.data-testid]="'goToAction' + row.id" pTooltip="{{ 'baskets.goToPromo' | translate }}"
            class="roundedButton row-buttom-margin">
            <i class="pi pi-eye icon-size"></i>
          </button>

        </div>

      </ng-template>

    </app-campaign-3-kontable>
  </div>


</div>


// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-promo-list/basket-promo-list.component.html